import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { MoreHorizontal } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { useT } from '../../i18n';
import { navFor, type NavItem } from '../../config/navigation';
import { Modal } from '../common/Modal';

function Tab({ item, onClick }: { item: NavItem; onClick?: () => void }) {
  const t = useT();
  return (
    <NavLink
      to={item.path}
      end
      onClick={onClick}
      data-testid={`bottom-nav-${item.key}`}
      className={({ isActive }) =>
        `flex min-h-16 flex-col items-center justify-center gap-0.5 py-1 text-[11px] font-semibold transition-colors duration-200 ${
          isActive ? 'text-sc-teal' : 'text-slate-500'
        }`
      }
    >
      {({ isActive }) => (
        <>
          <span className={`flex h-8 w-12 items-center justify-center rounded-full ${isActive ? 'bg-sc-soft' : ''}`}>
            <item.icon className="h-5 w-5" />
          </span>
          {/* Short label where one exists ("Rx"); long ones wrap onto two lines rather than being cut off. */}
          <span className="line-clamp-2 max-w-full px-1 text-center leading-tight">{t(`navShort.${item.key}`) === `navShort.${item.key}` ? t(`nav.${item.key}`) : t(`navShort.${item.key}`)}</span>
        </>
      )}
    </NavLink>
  );
}

export function BottomNav() {
  const { role } = useApp();
  const t = useT();
  const [open, setOpen] = useState(false);
  const items = navFor(role);
  const primary = items.slice(0, 4);
  const rest = items.slice(4);

  return (
    <>
      <nav className="print:hidden fixed inset-x-0 bottom-0 z-30 grid grid-cols-5 border-t border-sc-line bg-white pb-[env(safe-area-inset-bottom)] lg:hidden" data-testid="bottom-nav">
        {primary.map((item) => (
          <Tab key={item.key} item={item} />
        ))}
        {rest.length > 0 && (
          <button type="button" onClick={() => setOpen(true)} data-testid="bottom-nav-more" className="flex h-16 flex-col items-center justify-center gap-1 text-[11px] font-semibold text-slate-500">
            <span className="flex h-8 w-12 items-center justify-center rounded-full">
              <MoreHorizontal className="h-5 w-5" />
            </span>
            {t('nav.more')}
          </button>
        )}
      </nav>
      <Modal open={open} title={t('nav.more')} onClose={() => setOpen(false)} testId="more-menu">
        <div className="grid grid-cols-3 gap-2">
          {rest.map((item) => (
            <Tab key={item.key} item={item} onClick={() => setOpen(false)} />
          ))}
        </div>
      </Modal>
    </>
  );
}
